import styled, { keyframes } from 'styled-components';
import { rgba } from 'foundations-components/transitional/utils/color';
import { THUNDERDOME, THUNDERDOME_DARK, OLAF } from 'HubStyleTokens/colors';
import FloatyWrapper from './FloatyWrapper';
import { calculateAnimationRenderOffset } from '../../utils/animation';
import { jsx as _jsx } from "react/jsx-runtime";
const fadeInAnimation = keyframes(["from{opacity:0}to{opacity:1}"]);
const pulseAnimation = ({
  theme
}) => keyframes(["0%{box-shadow:0 0 0 0 ", ";}70%{box-shadow:0 0 0 6px ", ";}100%{box-shadow:0 0 0 6px ", ";}"], rgba(theme.color['fill-accent-purple-default'], 0.7), rgba(theme.color['fill-accent-purple-default'], 0), rgba(theme.color['fill-accent-purple-default'], 0));
const BUTTON_SIZE = 32;
const RoundButton = styled.button.withConfig({
  displayName: "CoachingTipButton__RoundButton",
  componentId: "sc-13rzsj5-0"
})([".hs-private.hs-private.hs-private &{border-radius:50%;padding:0;background-color:", ";border:0;color:", ";font-weight:500;opacity:0;width:", "px;height:", "px;font-size:14px;line-height:", "px;box-shadow:0 0 0 0 ", ";animation:", " 2s ", "s infinite,", " 0.5s ", "s forwards;}.hs-private.hs-private.hs-private &:hover{background-color:", ";}"], THUNDERDOME, OLAF, BUTTON_SIZE, BUTTON_SIZE, BUTTON_SIZE, rgba(THUNDERDOME, 0), pulseAnimation, ({
  animationRenderOffset
}) => 0.7 * animationRenderOffset, fadeInAnimation, ({
  animationRenderOffset
}) => 0.7 * animationRenderOffset, THUNDERDOME_DARK);
const CoachingTipButton = ({
  className,
  onTipClick,
  onTipRender,
  onTipUnmount,
  placement,
  target,
  tipId,
  tipIndex,
  zIndex
}) => {
  const buttonProps = {
    className: `coaching-tips-button${className ? ` ${className}` : ''}`,
    'data-coaching-tips-button': tipId,
    'data-test-id': `${tipId}-coaching-tip-button`,
    tipIndex,
    onClick: onTipClick
  };
  const handleAnimationEnd = () => {
    const thisTipElement = document.querySelector(`[data-coaching-tips-button="${tipId}"`);
    if (thisTipElement) {
      thisTipElement.classList.add('finished-animating');
    }
  };
  return /*#__PURE__*/_jsx(FloatyWrapper, {
    onTipRender: onTipRender,
    onTipUnmount: onTipUnmount,
    placement: placement,
    target: target,
    zIndex: zIndex,
    children: /*#__PURE__*/_jsx(RoundButton, Object.assign({
      onAnimationEnd: handleAnimationEnd,
      animationRenderOffset: calculateAnimationRenderOffset(tipIndex - 1)
    }, buttonProps, {
      children: "i"
    }))
  });
};
export default CoachingTipButton;